<script>
import chartFunnel from 'chartjs-plugin-funnel-x'
import { generateChart } from 'vue-chartjs'
import { widgetMixins } from '@/shared/WidgetMixins'
export default {
  extends: generateChart('funnel-chart', 'funnel'),
  mixins: [widgetMixins],
  name: 'FunnelChart',

  props: {
    chart: null,
    height: 450,
    asPyramid: null,
    h: null,
    w: null
  },

  data () {
    return {
      datasets: [],
      labels: [],
      funnel_order: null
    }
  },

  mounted () {
    this.addPlugin(chartFunnel)
  },

  methods: {
    createChart (sort) {
      let dataNew
      var originalDataset = this.datasets[0].data
      let dataLength = this.datasets[0].data.length
      if (sort === 'asc') {
        originalDataset = originalDataset.reverse()
      }
      if (this.asPyramid) {
        dataNew = { data: [], backgroundColor: []}
        for(let i = 0;  i < dataLength; i++){
          dataNew.data.push(dataLength - i)
          dataNew.backgroundColor.push(this.$defaultColors[i])
        }
        if (sort === 'desc') {
          dataNew.data.push(0)
        }
        dataNew = [dataNew]
      } else {
        dataNew = this.datasets
        dataNew[0].backgroundColor = this.$defaultColors.slice(0,dataLength-1)
      }
      this.$refs.canvas.height = this.h * 90
      this.renderChart(
        {
          datasets: dataNew,
          labels: this.labels
        },
        {
          responsive: true,
          legend: {
            display: !this.disableLegend,
            labels: {
            generateLabels: function(){
              var labels = this.labels.map(function(label){
                var index = this.labels.indexOf(label)
                var value = this.datasets[0].data[index]
                var color = dataNew[0].backgroundColor[index]
                return {
                  text: label + ': ' + value,
                  index: index,
                  fillStyle: color
                }
              }.bind(this))
              return labels
            }.bind(this)

            }
          },
          maintainAspectRatio: true,
          sort: sort,
          topWidth: 0,
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                return data.labels[tooltipItem.index] + `: ${originalDataset[tooltipItem.index]}`
              }
            }
          }
        }
      )
    },

    addColors () {
    }
  }

}
</script>
